module.exports = __webpack_public_path__ + "img/2024-07-01c_1.b5a45f72.jpg";